(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxUpdateGoOnPrinter(
    toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        printer: '=printer',
        onDeviceConfig: '=currentOnDeviceConfig',
        meta: '=meta',
        callback: '&callback'
      },
      
      templateUrl: 'app/components/onDeviceConfigProperties/updateGoOnPrinter/updateGoOnPrinter.template.html',
      link: function(scope) {

        scope.confirm = {
          update: false
        };

        (function() {})();

        scope.update = function () {
          scope.printer.updateDeviceConfig().then(function() {
            toastr.success($filter('translate')('Updated'));
          }).catch(function() {
            scope.ongoingUpdateConfigOnPrinter = false; 
            toastr.error($filter('translate')('Error'));
          });
          scope.callback();
        }

      }
    };
  }

  pxUpdateGoOnPrinter.$inject = ['toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxUpdateGoOnPrinter', pxUpdateGoOnPrinter);

})();
